import { render, staticRenderFns } from "./SuperBono2View.vue?vue&type=template&id=defaecf4&"
import script from "./SuperBono2View.vue?vue&type=script&lang=js&"
export * from "./SuperBono2View.vue?vue&type=script&lang=js&"
import style0 from "./SuperBono2View.vue?vue&type=style&index=0&id=defaecf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports